module.exports = __webpack_public_path__ + "static/media/18import-42.ee5b6249.xlsx";